import React from 'react'
import { Link } from 'react-router-dom'
import erimg from '../../images/cta/left-img4.png'
import erimg2 from '../../images/cta/left-img5.png'


const CtaBannerS3 = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="cta-banner-section3">
            <div className="container">
                <div className="cta-banner-wrap">
                    <div className="cta-banner cta-banner-left">
                        <div className="cta-banner-img">
                            <img src={erimg} alt="" />
                        </div>
                        <div className="small-heading-title">
                            <h3>Sale off 20%</h3>
                            <h5>On Sanitizers</h5>
                            <Link onClick={ClickHandler} to="/shop" className="small-btn-style">Shop Now</Link>
                        </div>
                    </div>
                    <div className="cta-banner cta-banner-right">
                        <div className="cta-banner-img">
                            <img src={erimg2} alt="" />
                        </div>
                        <div className="small-heading-title">
                            <span>New Products</span>
                            <h3>When purchasing any CocoSoul product as a gift Parachute 100% coconut oil.</h3>
                            <Link onClick={ClickHandler} to="/shop" className="small-btn-style">Shop Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaBannerS3;